import React from 'react';

const FeesAndCharges = () => {
  return (
    <div className="container py-5">
      <h1 className="mb-4">Fees and Charges</h1>

      <ul className="list-unstyled ps-3">
        <li className="mb-3 d-flex align-items-start">
          <span className="me-2" style={{ color: '#4CAF50', fontSize: '1.2rem' }}>✔️</span>
          <span>XLR8 does not charge the seller any fees.</span>
        </li>

        <li className="mb-3 d-flex align-items-start">
          <span className="me-2" style={{ color: '#4CAF50', fontSize: '1.2rem' }}>✔️</span>
          <span>XLR8 charges the buyer a 1% commission based on the transaction value of the vehicle as reflected on the auction.</span>
        </li>

        <li className="mb-3 d-flex align-items-start">
          <span className="me-2" style={{ color: '#4CAF50', fontSize: '1.2rem' }}>✔️</span>
          <span>The minimum commission is 1% or SGD $250, whichever is higher.</span>
        </li>

        <li className="mb-3 d-flex align-items-start">
          <span className="me-2" style={{ color: '#4CAF50', fontSize: '1.2rem' }}>✔️</span>
          <span>The maximum commission is capped at SGD $5,000.</span>
        </li>
      </ul>
    </div>
  );
};

export default FeesAndCharges;
